import React from 'react'

import { NavLink } from 'react-router-dom'

import { List, ListItem, ListItemText, useTheme } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const MonitorNavLinks = (props) => {
	const { selectedFacility } = props
	const classes = useStyles()

	return (
		<List className={classes.defaultNav}>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/monitor/staffNotes`}>
				<ListItemText primary="Staff Notes" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/monitor/activities`}>
				<ListItemText primary="Activities" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/monitor/playgroups`}>
				<ListItemText primary="Playgroups" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/monitor/schedule`}>
				<ListItemText primary="Play Yard Schedule" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/monitor/kennels`}>
				<ListItemText primary="Kennels" />
			</ListItem>
			{selectedFacility ? (
				<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/facilities/${selectedFacility._id}/monitor/dashboard`}>
					<ListItemText primary="On Deck" />
				</ListItem>
			) : null}
		</List>
	)
}

export default MonitorNavLinks
